import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const billingPlanLimitedAlert = theme => css`
  min-height: ${theme.spacing[16]};
  background: ${theme.color.primary.negativeAlt};
  button {
    font-weight: ${theme.fontWeight.semibold};
  }
`

const billingPlanLimitedOverdueAlert = css`
  background: #d60000;
`

const learnMoreLink = theme => css`
  &&& {
    color: ${theme.color.primary.info};
    text-decoration: underline;
  }
`

const migrationContent = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
  flex-wrap: wrap;
`

const migrationText = css`
  flex: 1;
  min-width: 0;
`

const annualReminderBar = theme => css`
  background: ${theme.color.info['50']};
  border-bottom: 1px solid ${theme.color.info['100']};
  padding: ${rem(10)} ${rem(20)};
  color: ${theme.color.monochrome.black};
  font-weight: ${theme.fontWeight.normal};
  text-align: left;
`

const annualReminderContent = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${rem(14)};
  width: 100%;
`

const annualReminderText = theme => css`
  flex: 1 1 ${rem(420)};
  min-width: 0;
  font-size: ${theme.fontSize.large};
  line-height: 1.45;
  strong {
    font-weight: ${theme.fontWeight.bold};
  }
`

const annualReminderIcon = theme => css`
  color: ${theme.color.info['500']};
  display: inline-flex;
  flex: none;
  svg {
    width: ${rem(22)};
    height: ${rem(22)};
  }
`

const annualReminderButton = theme => css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  min-width: ${rem(44)};
  min-height: ${rem(44)};
  padding: 0 ${rem(20)};
  border-width: 0;
  border-radius: ${rem(999)};
  background-color: transparent;
  color: ${theme.color.monochrome.black};
  font-family: inherit;
  font-size: ${theme.fontSize.large};
  font-weight: ${theme.fontWeight.semibold};
  line-height: 1.45;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid ${theme.color.info['900']};
    outline-offset: 2px;
  }
`

const annualReminderPrimary = theme => css`
  background-color: ${theme.color.info['500']};
  color: ${theme.color.monochrome.white};
`

const annualReminderDismiss = theme => css`
  width: ${rem(44)};
  height: ${rem(44)};
  padding: 0;
  font-size: ${rem(24)};
  color: ${theme.color.monochrome.dark};
`

export const styles = {
  annualReminderBar,
  annualReminderContent,
  annualReminderText,
  annualReminderPrimary,
  annualReminderDismiss,
  annualReminderIcon,
  annualReminderButton,
  billingPlanLimitedAlert,
  billingPlanLimitedOverdueAlert,
  learnMoreLink,
  migrationContent,
  migrationText,
}
